const isSandbox = () => ['development', 'sandbox'].includes(process.env.REACT_APP_ENVIRONMENT);

export default isSandbox;
